import { render, staticRenderFns } from "./aftersaleOrderVo.vue?vue&type=template&id=3fb95e02&scoped=true&"
import script from "./aftersaleOrderVo.vue?vue&type=script&lang=js&"
export * from "./aftersaleOrderVo.vue?vue&type=script&lang=js&"
import style0 from "./aftersaleOrderVo.vue?vue&type=style&index=0&id=3fb95e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb95e02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb95e02')) {
      api.createRecord('3fb95e02', component.options)
    } else {
      api.reload('3fb95e02', component.options)
    }
    module.hot.accept("./aftersaleOrderVo.vue?vue&type=template&id=3fb95e02&scoped=true&", function () {
      api.rerender('3fb95e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale-nc/detail/components/aftersaleOrderVo.vue"
export default component.exports